import React, { useState, useEffect, useMemo } from 'react';
import { useQuery, useReactiveVar } from '@apollo/client';
import { makeStyles } from '@material-ui/core/styles';
import { CircularProgress, Container, Divider, Grid, Paper, Tabs, Tab, Typography } from '@material-ui/core';
import { GetDestinationDocument, GetEtlsByDestinationDocument, GetChartsByDestinationDocument, } from '../../generated/graphql';
import { errorsVar } from '../../cache';
import PageLayout from '../components/PageLayout';
import PageTitle from '../components/PageTitle';
import ChartBuilder from '../components/ChartBuilder';
import ChartUpdater from '../components/ChartUpdater';
import DestinationDetail from '../components/DestinationDetail';
import Lottie from '../components/Lottie';
import chartLoadingAnimation from '../../animations/chartloading.json';
import ChartContainer from '../components/ChartContainer/ChartContainer';
var DestinationDetailsPage = function (props) {
    var classes = useStyles();
    var _a = useState(), destination = _a[0], setDestination = _a[1];
    var _b = useState(0), tab = _b[0], setTab = _b[1];
    var _c = useQuery(GetDestinationDocument, {
        variables: { id: props.match.params.destinationId },
    }), destinationData = _c.data, destinationLoading = _c.loading, destinationRefecth = _c.refetch;
    var _d = useQuery(GetEtlsByDestinationDocument, {
        variables: { destinationId: props.match.params.destinationId },
    }), etlsData = _d.data, etlsLoading = _d.loading, error = _d.error;
    var _e = useQuery(GetChartsByDestinationDocument, {
        variables: { destinationId: props.match.params.destinationId },
    }), chartsData = _e.data, chartsLoading = _e.loading;
    var errors = useReactiveVar(errorsVar);
    useEffect(function () {
        setDestination(destinationData === null || destinationData === void 0 ? void 0 : destinationData.destination);
    }, [destinationData]);
    var handleTabChange = function (_, newValue) {
        setTab(newValue);
    };
    var showCharts = useMemo(function () {
        var _a;
        if (chartsLoading)
            return (React.createElement(Container, null,
                React.createElement(Paper, { className: classes.chartRoot },
                    React.createElement(Lottie, { data: chartLoadingAnimation, loop: true, width: 300, height: 300 }),
                    React.createElement(Typography, { className: classes.chartLoading, variant: "h6" },
                        ' ',
                        "Loading Charts...",
                        ' '))));
        if (!destination)
            return;
        return (_a = chartsData === null || chartsData === void 0 ? void 0 : chartsData.chartsByDestination) === null || _a === void 0 ? void 0 : _a.map(function (chart, i) { return (React.createElement(Container, { key: i },
            React.createElement(Paper, { className: classes.chartRoot },
                React.createElement(Typography, { className: classes.chartTitle, variant: "h5" }, chart.name ? chart.name + " #" + chart.id : "Chart " + i + " #" + chart.id),
                React.createElement(ChartUpdater, { columns: destination.columns, chartId: chart.id }),
                React.createElement(Divider, { className: classes.divider }),
                React.createElement(ChartContainer, { chartId: chart.id, initialChart: chart })))); });
    }, [chartsData, chartsLoading, destination]);
    if (destinationLoading || etlsLoading)
        return React.createElement(CircularProgress, null);
    if (destination) {
        return (React.createElement(PageLayout, null,
            etlsData && etlsData.etlsByDestination.length > 1 ? (React.createElement(React.Fragment, null,
                React.createElement(PageTitle, { gridSize: 6, title: destination.name ? destination.name : 'Destination Details' }),
                React.createElement(Grid, { item: true, xs: 6, className: classes.tabsGrid },
                    React.createElement(Tabs, { value: tab, indicatorColor: "primary", onChange: handleTabChange }, etlsData.etlsByDestination.map(function (etl, i) { return (React.createElement(Tab, { label: etl.name, key: i })); }))),
                React.createElement(DestinationDetail, { destination: destination, etl: etlsData.etlsByDestination[tab], reload: destinationRefecth }))) : etlsData ? (React.createElement(React.Fragment, null,
                React.createElement(PageTitle, { gridSize: 12, title: destination.name ? destination.name : 'Destination Details' }),
                React.createElement(DestinationDetail, { destination: destination, etl: etlsData.etlsByDestination[0], reload: destinationRefecth }))) : null,
            showCharts,
            React.createElement(ChartBuilder, { destinationData: destination.previews, destination: destination })));
    }
    return React.createElement(PageLayout, null);
};
var useStyles = makeStyles({
    tabsGrid: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    chartLoading: {
        textAlign: 'center',
    },
    chartRoot: {
        padding: '10px 10px 60px',
        margin: 20,
    },
    chartTitle: {
        marginLeft: 10,
        float: 'left',
    },
    divider: {
        marginTop: 46,
    },
});
export default DestinationDetailsPage;
